import { BodyShort01 } from 'module/ui/components/styles';
import { faInfo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, ReactElement } from 'react';
import styled from 'styled-components';
import {
  InlineNotificationKey,
  InlineNotificationType,
} from './inline-notification-types';

const InfoIcon = styled(FontAwesomeIcon).attrs({
  icon: faInfo,
})``;
const Message = styled.div`
  ${BodyShort01};
  display: flex;
  align-items: center;

  ${InfoIcon} {
    color: var(--warning-border-color);
  }
`;

const Control = styled.div`
  ${BodyShort01};
`;

const getStyle = (props, key) => {
  switch (key) {
    case InlineNotificationKey.BgColor:
      switch (props.type) {
        case InlineNotificationType.Error:
          return 'var(--red-10)';
        case InlineNotificationType.Warning:
          return 'var(--private-01)';
        case InlineNotificationType.Success:
          return 'var(--green-10)';
        case InlineNotificationType.Info:
          return 'var(--blue-10)';
        default:
          return 'none';
      }

    case InlineNotificationKey.Border:
      switch (props.type) {
        case InlineNotificationType.Error:
          return '1px solid var(--red-30)';
        case InlineNotificationType.Warning:
          return '1px solid var(--warning-border-color)';
        case InlineNotificationType.Success:
          return '1px solid var(--green-30)';
        default:
          return 'none';
      }

    case InlineNotificationKey.BorderLeftColor:
      switch (props.type) {
        case InlineNotificationType.Error:
          return 'var(--red-50)';
        case InlineNotificationType.Warning:
          return 'var(--warning-border-color)';
        case InlineNotificationType.Success:
          return 'var(--green-50)';
        default:
          return 'none';
      }
    case InlineNotificationKey.Svg:
      switch (props.type) {
        case InlineNotificationType.Error:
          return 'var(--red-50)';
        case InlineNotificationType.Warning:
          return 'var(--warning-border-color)';
        case InlineNotificationType.Success:
          return 'var(--green-50)';
        case InlineNotificationType.Info:
          return 'var(--blue-50)';
        default:
          return 'none';
      }

    default:
      return 'none';
  }
};

const Wrapper = styled.div<{ type: string }>`
  margin-bottom: var(--spacing-05);
  background-color: ${(props) =>
    getStyle(props, InlineNotificationKey.BgColor)};
  border: ${(props) => getStyle(props, InlineNotificationKey.Border)};
  border-left-width: 4px;
  border-left-color: ${(props) =>
    getStyle(props, InlineNotificationKey.BorderLeftColor)};
  padding: var(--spacing-03) var(--spacing-05);
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${Message} {
    svg {
      color: ${(props) => getStyle(props, InlineNotificationKey.Svg)};
      margin-right: var(--spacing-05);
    }
    width: 80%;
  }
`;

interface Props {
  msg: ReactElement;
  icon: ReactElement;
  button?: ReactElement;
  type: InlineNotificationType;
}

export const InlineNotification: FC<React.PropsWithChildren<Props>> = ({
  msg,
  icon,
  button,
  type,
}) => {
  return (
    <Wrapper type={type}>
      <Message>
        {icon} {msg}
      </Message>
      {button && <Control>{button}</Control>}
    </Wrapper>
  );
};
